import { Body, breakpoints, colors, Margin, Spacer } from '@spritz-finance/ui'
import { useEffect } from 'react'
import styled from 'styled-components'
import { Card } from '../../components/Layout/Card'
import { CenteredPageInner, PageContainer } from '../../components/Layout/PageContainer'
import { useCurrentUser } from '../../context/useCurrentUser'
import { useGrowsurfContext } from '../../context/useGrowsurf'
import { useReferralStatsQuery } from '../../graphql/generated/graphql'
import { ItemWrapper } from './item'

const StatBox = styled(Card)`
    text-align: center;
    width: 132px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${breakpoints.small} {
        width: auto;
        margin-bottom: ${Margin.Med};
    }
`

const Stat = styled.div`
    font-size: 50px;
`

const Stats = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    ${breakpoints.small} {
        flex-direction: column;
    }
`

const Divider = styled.div`
    margin-bottom: ${Margin.Large};
    border-bottom: 1px solid var(--surface-3, ${colors.ltGrey});
`

const GRSFContainer = styled.div`
    .grsf-share-instructions h5,
    .grsf-referral-status-inner h5 {
        color: var(--text-primary, ${colors.black});
    }

    a.grsf-block-form-powered-by-link {
        opacity: 0 !important;
    }
`

export default function ReferralsSubPage() {
    const { me } = useCurrentUser()
    const { data } = useReferralStatsQuery()
    const { loaded, init } = useGrowsurfContext()

    useEffect(() => {
        if (loaded) {
            init()
        }
    }, [loaded])

    return (
        <CenteredPageInner $width={600}>
            <PageContainer>
                <Card>
                    <Spacer height={16} />
                    <GRSFContainer
                        data-grsf-block-form
                        data-grsf-email={me.email}
                        data-grsf-first-name={me.firstName}
                        data-grsf-last-name={me.lastName}
                    />
                    <Divider />
                    Refresh your finances with frens. When a friend pays their first IRL bill(s) on
                    Spritz totaling $50 through your referral link, you’ll both earn $50 in rewards.
                    <Spacer height={8} />
                    <ol>
                        <ItemWrapper>Share your Spritz referral link anywhere</ItemWrapper>
                        <ItemWrapper>
                            Earn rewards as soon as your friend’s qualifying bill payment clears
                        </ItemWrapper>
                        <ItemWrapper>Pay off your own bills with your referral rewards</ItemWrapper>
                    </ol>
                </Card>

                <Spacer height={56} />

                <Stats>
                    <StatBox>
                        <Stat>${data?.referralStats?.rewardsEarned}</Stat>
                        <Body.Med size={14}>Rewards earned</Body.Med>
                    </StatBox>
                    <StatBox>
                        <Stat>{data?.referralStats?.qualifiedReferrals}</Stat>
                        <Body.Med size={14}>Bill payers referred</Body.Med>
                    </StatBox>
                    <StatBox>
                        <Stat>{data?.referralStats?.signups}</Stat>
                        <Body.Med size={14}>Successful signups</Body.Med>
                    </StatBox>
                </Stats>

                <Spacer height={56} />

                <Card>
                    <GRSFContainer data-grsf-block-referral-status></GRSFContainer>
                </Card>
            </PageContainer>
        </CenteredPageInner>
    )
}
